module.exports = __webpack_public_path__ + "img/provider7.1e4a4c6b.png";